import { useAppKit } from '@reown/appkit/react';
import { Button, ButtonProps } from '../shared/button/button';

const ConnectButton = (props: Omit<ButtonProps, 'onClick'>) => {
  const { open } = useAppKit();

  return (
    <Button
      {...props}
      onClick={async () => {
        await open();
      }}
    />
  );
};

export default ConnectButton;
